import React, { FC, useMemo, useCallback } from 'react'
import { ToggleButton, ViewToggleContainer, Icon, TabText } from './styles'
import { useTranslation } from '../../../hooks/locale'
import { buildPath } from '../../../routes/build-route'
import { useRouting } from '../../../hooks/routes'
import { HOME_PAGE_TYPE } from '../../../constants/home'
import { getBasePath } from '../../../utils/miscellaneous-utils'
import AnalyticsService from '../../../services/analytics-service'
import { pageTypeEventCategories } from '../../../services/analytics-service/categories'

interface Props {
    activeHomeType?: HOME_PAGE_TYPE
}

type ToggleConfig = {
    key: string
    label: string
    route: string
    icon: string
}

const SliderSection: FC<Props> = ({ activeHomeType = HOME_PAGE_TYPE.HOME }) => {
    const { t } = useTranslation()
    const { r } = useRouting()

    const inquiryIconPath = getBasePath('/assets/images/home/inquiry.png')
    const bookingIconPath = getBasePath('/assets/images/home/booking.png')

    const toggleOptions: ToggleConfig[] = useMemo(
        () => [
            {
                key: HOME_PAGE_TYPE.HOME,
                label: t('makeInquiry'),
                route: r('home'),
                icon: inquiryIconPath,
            },
            {
                key: HOME_PAGE_TYPE.BOOKING,
                label: t('bookConfirmedStay'),
                route: r('bookingHome'),
                icon: bookingIconPath,
            },
        ],
        [r, t],
    )

    const handleNavigation = useCallback((route: string, key: string) => {
        AnalyticsService.trackClickEvent(pageTypeEventCategories.HOME, key)
        window.location.href = buildPath(route)
    }, [])

    return (
        <ViewToggleContainer>
            {toggleOptions.map(({ key, label, route, icon }) => {
                const isActive = activeHomeType === key

                return (
                    <ToggleButton
                        key={key}
                        isActive={isActive}
                        disabled={isActive}
                        onClick={!isActive ? () => handleNavigation(route, key) : undefined}
                    >
                        <Icon src={icon} alt={label} />
                        <TabText>{label}</TabText>
                    </ToggleButton>
                )
            })}
        </ViewToggleContainer>
    )
}

export default SliderSection
